const mutations = {
  setMeetingDetailesMeetingId(state, payload) {
    state.meetingDetails = { ...state.meetingDetails, meetingId: payload };
  },
  setMeetingDetailesBuildingId(state, payload) {
    state.meetingDetails = { ...state.meetingDetails, buildingId: payload };
  },
  setMeetingDetailesBuildingOwnersData(state, payload) {
    state.meetingDetails = { ...state.meetingDetails, BuildingOwnersData: payload };
  },
};

export default mutations;
